// src/components/StepIndicator.jsx
import React from 'react';

const StepIndicator = ({ currentStep, totalSteps }) => (
  <div className="step-indicator">
    {Array.from({ length: totalSteps }).map((_, idx) => (
      <div
        key={idx}
        className={`step-bullet ${currentStep === idx + 1 ? 'active' : ''}`}
      >
        {idx + 1}
      </div>
    ))}
  </div>
);

export default StepIndicator;
